import { Suspense } from "react";
import dynamic from "next/dynamic";
import { ArticleSection } from "@business-finland/wif-ui-lib/dist/ArticleSection";

const HtmlParser = dynamic(() => import("../../../components/HtmlParser"));

interface IArticleFooterSectionProps {
  leadText: string;
}

export function ArticleFooterSection({
  leadText,
}: IArticleFooterSectionProps): JSX.Element {
  return (
    <Suspense>
      <ArticleSection
        isFooterSection={true}
        bodyText={<HtmlParser html={leadText} />}
      />
    </Suspense>
  );
}
